export const isNonProductionEnvironment = () => {
  const currentEnvironment = process.env.REACT_APP_LOGGER_ENVIRONMENT;

  let isLowerEnvironment = false;

  console.log("CURRENT ENVIRONMENT, ", currentEnvironment);

  if (
    currentEnvironment !== 'prod'
    && currentEnvironment !== 'production'
  ) { 
    isLowerEnvironment = true;
  }

  return isLowerEnvironment;
};